module.exports = __webpack_public_path__ + "static/media/infoRed.edf2a27c.svg";